import React from "react";
import "./NabhNahlAccr.css"; // Import CSS file
import NabhMain from "../image/NabhMain.jpg";

function NabhNahlAccr() {
  return (
    <div className="nabh-container">
      {/* Top Half: Background Image Section */}
      <div
        className="nabh-image-section"
        style={{ backgroundImage: `url(${NabhMain})` }}
      >
        {/* Dark Overlay */}
        <div className="nabh-overlay"></div>

        {/* Title Over Image */}
        <h1 className="nabh-title">NABH & NABL Accreditation</h1>
      </div>

      {/* Bottom Half: Content Section */}
      <div className="nabh-content-section">
        <div className="nabh-content-wrapper">
          <strong className="nabh-heading">NABH Accreditation</strong>
          <p className="nabh-paragraph">
            Achieving NABH accreditation demonstrates our commitment to
            providing high-quality healthcare services. This recognition shows
            that we adhere to the highest standards of patient safety and care,
            fostering trust and confidence in our services.
          </p>

          <strong className="nabh-heading">NABL Accreditation</strong>
          <p>
            We are dedicated to helping organizations achieve the highest
            standards of quality and excellence. Our team of experts is here to
            guide you through the accreditation process, ensuring a smooth and
            efficient experience. Let us help you elevate your organization’s
            credibility and reputation today!
          </p>
        </div>
      </div>
    </div>
  );
}

export default NabhNahlAccr;
